import { render, staticRenderFns } from "./Shouye.vue?vue&type=template&id=d0d3fc84&scoped=true&"
import script from "./Shouye.vue?vue&type=script&lang=js&"
export * from "./Shouye.vue?vue&type=script&lang=js&"
import style0 from "./Shouye.vue?vue&type=style&index=0&id=d0d3fc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d3fc84",
  null
  
)

export default component.exports